import FormBanner from './Banner';
import FormButton from './FormButton';
import FormLabel from './FormButtonLabel';
import FormField from './FormField';
import FormInput from './FormInput';
import FormLink from './FormLink';
import FormLogin from './Login';
import FormRecoverPassword from './RecoverPassword';
import Export from './Export';
import Validity from './Validity';

export interface FormProps
  extends React.DetailedHTMLProps<
    React.FormHTMLAttributes<HTMLFormElement>,
    HTMLFormElement
  > {}

export default Object.assign(
  ({ children, className = '', ...rest }: FormProps) => {
    return (
      <form className={`form ${className}`} {...rest}>
        {children}
      </form>
    );
  },
  {
    Button: FormButton,
    Login: FormLogin,
    Banner: FormBanner,
    Input: FormInput,
    Label: FormLabel,
    Field: FormField,
    Link: FormLink,
    RecoverPassword: FormRecoverPassword,
    Export,
    Validity,
  },
);
